import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
  inject,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Agrupacion,
  Dia,
  Frecuencia,
  IActivo,
  ICategoriaEvento,
  ICodigoDispositivo,
  IConfigEventoUsuario,
  ICreateConfigEventoUsuario,
  ICreateListadoCategoria,
  IDispositivoAlarma,
  IFilter,
  IGrupo,
  IListado,
  ILuminaria,
  IQueryParam,
  IListadoCategoria,
  IUbicacion,
  IUpdateConfigEventoUsuario,
  IUsuario,
  TipoEntidad,
  TipoEnvio,
} from 'modelos/src';
import {
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
} from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DateRange } from '../../../../auxiliares/date-range-selector/date-range-selector.component';
import { ConfigEventoUsuarioService } from '../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { ParamsService } from '../../../../auxiliares/servicios/params.service';
import { ListadoCategoriasService } from '../../../../auxiliares/servicios/http/listado-categorias.service';
import { CrearEditarCategoriaEventoComponent } from '../../../entidades/configuracion/categorias-eventos/crear-editar-categoria-evento/crear-editar-categoria-evento.component';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { PermisosEntidadesService } from '../../../../auxiliares/servicios/http/permisos-entidades.service';
import { HintComponent } from '../../../../componentes/hint/hint.component';
import { DiasSemanaSelectorComponent } from '../../../../componentes/dias-semana-selector/dias-semana-selector.component';
import { TimePickerComponent } from '../../../../componentes/time-picker/time-picker.component';
import { frecuenciasAdmitidas } from '../../../../auxiliares/frecuencias-regla.util';
import {
  cronogramaLocalAUtc,
  cronogramaUtcALocal,
} from '../../../../auxiliares/cronograma-utc.util';
import { ContentCardComponent } from '../../../../componentes/content-card/content-card.component';
import { SectionTitleComponent } from '../../../../componentes/section-title/section-title.component';
import { InfoBannerComponent } from '../../../../componentes/info-banner/info-banner.component';
import { ListadoCategoriasSelectorComponent } from '../../../../componentes/selectores/listado-categoria-selector/listado-categoria-selector.component';

interface ITipoCondicion {
  tipo: TipoEntidad;
  valor: string;
}

export interface IParamEventoUsuario {
  tipoEntidad?: TipoEntidad;
  listadoCategoria?: IListadoCategoria;
  categoriaEvento?: ICategoriaEvento;
  agrupacion?: 'Grupo' | 'Entidad';
  idGrupo?: string;
  idEntidad?: string;
  tipoCondicion?: string;
  crear?: 'Dialog' | 'Page';
  botonCrear?: boolean;
  alarma?: string | IDispositivoAlarma;
  [key: string]: any;
}

@Component({
  imports: [
    CommonModule,
    AuxiliaresModule,
    HintComponent,
    ContentCardComponent,
    SectionTitleComponent,
    InfoBannerComponent,
    DiasSemanaSelectorComponent,
    TimePickerComponent,
    ListadoCategoriasSelectorComponent,
  ],
  selector: 'app-crear-editar-config-evento-usuario-dialog',
  templateUrl: './crear-editar-config-evento-usuario-dialog.component.html',
  styleUrls: ['./crear-editar-config-evento-usuario-dialog.component.scss'],
})
export class CrearEditarConfigEventoUsuarioDialogComponent
  implements OnInit, OnDestroy
{
  dialogData = inject<{
    edit: IConfigEventoUsuario;
    params: IParamEventoUsuario;
  }>(MAT_DIALOG_DATA, { optional: true });
  dialogRef = inject<
    MatDialogRef<CrearEditarConfigEventoUsuarioDialogComponent>
  >(MatDialogRef, { optional: true });
  private service = inject(ConfigEventoUsuarioService);
  private lista2 = inject(Lista2Service);
  private listadoCategoriasService = inject(ListadoCategoriasService);
  private paramsService = inject(ParamsService);
  helper = inject(HelperService);
  private formularios = inject(FormularioDialogService);
  route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private permisosEntidadesService = inject(PermisosEntidadesService);

  @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;

  onScroll(): void {
    this.ngSelects?.forEach((s) => s.close());
  }

  public loading = false;
  public form?: FormGroup;
  public title?: string;
  public subtitle?: string;
  public height = 'unset';
  public maxHeight = 'unset';

  public range?: DateRange = {};
  public opcionesDeEventoAlarma = [
    'Código Único',
    'Códigos de Armado',
    'Códigos de Desarmado',
  ];
  public tiposEnvio: TipoEnvio[] = [
    // 'SMS',
    // 'WhatsApp',
    // 'Llamada',
    'Notificacion Push',
  ];
  public tiposAgrupaciones: {
    label: string;
    value: Agrupacion;
  }[] = [
    { label: 'Global', value: 'Global' },
    { label: 'Grupo', value: 'Grupo' },
    { label: 'Individual', value: 'Entidad' },
  ];
  public tiposEntidades: { label: string; value: TipoEntidad }[] = [
    { label: 'Activo', value: 'Activo' },
    { label: 'Vehículo', value: 'Vehiculo' },
    { label: 'Alarma', value: 'Alarma' },
    { label: 'Luminaria', value: 'Luminaria' },
  ];
  public tiposFrecuencias: { label: string; value: Frecuencia }[] = [
    { label: 'Única', value: 'Unica' },
    { label: 'Continua', value: 'Continua' },
    { label: 'Única en un periodo', value: 'Unica en un periodo' },
    { label: 'Continua en un periodo', value: 'Continua en un periodo' },
    { label: 'Cronograma', value: 'Cronograma' },
  ];
  public dias: Dia[] = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
  ];
  public tiposCondicion: ITipoCondicion[] = [
    { tipo: 'Activo', valor: 'Ubicación' },
    { tipo: 'Activo', valor: 'Velocidad' },
    { tipo: 'Activo', valor: 'Exceso de velocidad por calle' },
    { tipo: 'Activo', valor: 'Detenido' },
    { tipo: 'Vehiculo', valor: 'Ubicación' },
    { tipo: 'Vehiculo', valor: 'Velocidad' },
    { tipo: 'Vehiculo', valor: 'Exceso de velocidad por calle' },
    { tipo: 'Vehiculo', valor: 'Detenido' },
    { tipo: 'Vehiculo', valor: 'Recorridos' },
    { tipo: 'Vehiculo', valor: 'Divergencia GPS' },
    { tipo: 'Alarma', valor: 'Llega evento' },
    { tipo: 'Alarma', valor: 'No llega evento' },
    { tipo: 'Luminaria', valor: 'Potencia' },
    { tipo: 'Luminaria', valor: 'Voltaje' },
  ];

  // Datos de input al componente
  @Input() public edit?: IConfigEventoUsuario;
  @Input() public params?: IParamEventoUsuario = {};
  public codigosAlarma: ICodigoDispositivo[] = [];
  public mostrarZona: boolean;

  // Entidades
  public grupos: IGrupo[] = [];
  public listadoCategoriasActivos: IListadoCategoria[] = [];
  public listadoCategoriasAlarmas: IListadoCategoria[] = [];
  public listadoCategoriasLuminarias: IListadoCategoria[] = [];
  public listadoCategoriasTracker: IListadoCategoria[] = [];
  public categoriasEvento: ICategoriaEvento[] = [];

  public ubicacions: IUbicacion[] = [];
  public activos: IActivo[] = [];
  public vehiculos: IActivo[] = [];
  public alarmas: IDispositivoAlarma[] = [];
  public luminarias: ILuminaria[] = [];
  public usuarios: IUsuario[] = [];

  // Listado Continuo
  public grupos$?: Subscription;
  public categoriasEvento$: Subscription;
  public listadoCategorias$?: Subscription;
  public usuarios$?: Subscription;
  public ubicacions$?: Subscription;
  //Add Tag
  public creandoNuevoTag?: boolean = false;

  public listadoCategoriaInitialNames: string[] = [];

  public get categoriaTipoEvento(): string | null {
    switch (this.form?.get('tipoEntidad')?.value as TipoEntidad) {
      case 'Activo':
        return 'Evento-Activo';

      //Los vehículos no generan eventos por sí solo, lo hacen por medio del tracker que tienen asociado
      case 'Vehiculo':
        return 'Evento-Tracker';
      case 'Alarma':
        return 'Evento-Alarma';
      case 'Luminaria':
        return 'Evento-Luminaria';
      default:
        return null;
    }
  }

  public onListadoCategoriaChange(cat: IListadoCategoria | null): void {
    this.form?.get('idListadoCategoria')?.setValue(cat?._id ?? null);
  }

  get tipoEntidad() {
    return this.form?.get('tipoEntidad')?.value as TipoEntidad;
  }

  // Opciones de los ng-select memorizadas: un array nuevo en cada ciclo de
  // detección de cambios haría que ng-select recalcule sus ítems todo el tiempo.
  private cacheCondiciones?: { clave: string; items: ITipoCondicion[] };
  private cacheFrecuencias?: {
    clave: string;
    items: { label: string; value: Frecuencia }[];
  };

  /** Tipos de condición del módulo elegido. */
  get tiposCondicionDeEntidad(): ITipoCondicion[] {
    const clave = String(this.tipoEntidad);
    if (this.cacheCondiciones?.clave !== clave) {
      this.cacheCondiciones = {
        clave,
        items: this.tiposCondicion.filter((d) => d.tipo === this.tipoEntidad),
      };
    }
    return this.cacheCondiciones.items;
  }

  /** Igual que `frecuenciasDisponibles`, pero con la misma referencia mientras
   *  no cambien el módulo ni la condición. */
  get frecuenciasOpciones(): { label: string; value: Frecuencia }[] {
    const clave = `${this.tipoEntidad}|${this.tipoCondicion}`;
    if (this.cacheFrecuencias?.clave !== clave) {
      this.cacheFrecuencias = { clave, items: this.frecuenciasDisponibles };
    }
    return this.cacheFrecuencias.items;
  }

  /** Activos y vehículos: sólo las frecuencias que el backend de la condición
   *  elegida respeta (igual que el wizard de reglas de vehículo). */
  get frecuenciasDisponibles(): { label: string; value: Frecuencia }[] {
    if (this.tipoEntidad !== 'Activo' && this.tipoEntidad !== 'Vehiculo') {
      return this.tiposFrecuencias;
    }
    const admitidas = frecuenciasAdmitidas(this.tipoCondicion);
    return this.tiposFrecuencias.filter((f) => admitidas.includes(f.value));
  }

  /** Divergencia GPS sólo admite "Continua": no hay nada que elegir. */
  get muestraFrecuencia(): boolean {
    return (
      this.tipoEntidad !== 'Luminaria' && this.frecuenciasDisponibles.length > 1
    );
  }

  /** "Generar si no se cumple" sólo lo implementan las alarmas. */
  get admiteGenerarSiNoSeCumple(): boolean {
    return this.tipoEntidad === 'Alarma';
  }

  /** "Hasta" anterior a "Desde" es válido: el horario termina al día
   *  siguiente (p. ej. 22:00 a 06:00). */
  get cronogramaValido(): boolean {
    if (this.form?.get('frecuencia')?.value !== 'Cronograma') return true;
    const dias = this.form.get('dias')?.value;
    const ini = this.form.get('horaInicio')?.value;
    const fin = this.form.get('horaFin')?.value;
    return !!dias?.length && !!ini && !!fin && ini !== fin;
  }
  get configZona() {
    return this.form?.get('configZona') as FormGroup;
  }

  get configUbicacionActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('ubicacion') as FormGroup;
  }
  get configVelocidadActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('velocidad') as FormGroup;
  }
  get configExcesoVelocidadCalleActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('excesoVelocidadCalle') as FormGroup;
  }
  get configDetenidoActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('detenido') as FormGroup;
  }
  get configRecorridosActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('recorridos') as FormGroup;
  }
  get configDivergenciaGPSActivo() {
    return this.form
      ?.get('condicion')
      ?.get('activo')
      ?.get('divergenciaGPS') as FormControl;
  }
  get condicionAlarma() {
    return this.form?.get('condicion')?.get('alarma') as FormGroup;
  }
  get configLLegaEventoAlarma() {
    return this.form
      ?.get('condicion')
      ?.get('alarma')
      ?.get('llega evento') as FormControl;
  }
  get configNoLlegaEventoAlarma() {
    return this.form
      ?.get('condicion')
      ?.get('alarma')
      ?.get('no llega evento') as FormControl;
  }

  //Luminarias
  get configPotenciaLuminaria() {
    return this.form
      ?.get('condicion')
      ?.get('luminaria')
      ?.get('potencia') as FormGroup;
  }
  get configVoltajeLuminaria() {
    return this.form
      ?.get('condicion')
      ?.get('luminaria')
      ?.get('voltaje') as FormGroup;
  }
  get tipoCondicion() {
    return this.form?.get('tipoCondicion')?.value as
      | 'Ubicación'
      | 'Velocidad'
      | 'Exceso de velocidad por calle'
      | 'Detenido'
      | 'Recorridos'
      | 'Divergencia GPS'
      | 'Llega evento'
      | 'No llega evento'
      | 'Potencia'
      | 'Voltaje'
      | 'Recorridos';
  }

  private createForm(): void {
    this.title = this.edit?._id
      ? 'Editar Configuración de Evento'
      : 'Crear Configuración de Evento';

    const codigosArmados = this.edit?.alarma?.modelo?.codigos?.codigos?.filter(
      (c) => c.armado === true,
    );
    const codigosDesarmados =
      this.edit?.alarma?.modelo?.codigos?.codigos?.filter(
        (c) => c.desarmado === true,
      );
    let textTipo = null;
    if (
      this.edit?.condicion?.alarma?.['no llega evento']?.length > 0 ||
      this.edit?.condicion?.alarma?.['no llega evento']?.length > 0
    ) {
      textTipo = 'Codigo Unico';
    }
    if (this.edit?.condicion?.alarma?.['no llega evento']?.length > 1) {
      if (
        this.edit?.condicion?.alarma?.['no llega evento']?.find((c) =>
          codigosArmados.find((cod) => cod.codigo === c),
        )
      )
        textTipo = 'Codigos de Armado';
      if (
        this.edit?.condicion?.alarma?.['no llega evento']?.find((c) =>
          codigosDesarmados.find((cod) => cod.codigo === c),
        )
      )
        textTipo = 'Codigos de Desarmado';
    }
    if (this.edit?.condicion?.alarma?.['llega evento']?.length > 1) {
      if (
        this.edit?.condicion?.alarma?.['llega evento']?.find((c) =>
          codigosArmados.find((cod) => cod.codigo === c),
        )
      )
        textTipo = 'Codigos de Armado';
      if (
        this.edit?.condicion?.alarma?.['llega evento']?.find((c) =>
          codigosDesarmados.find((cod) => cod.codigo === c),
        )
      )
        textTipo = 'Codigos de Desarmado';
    }
    const condicion = new FormGroup({
      activo: new FormGroup({
        ubicacion: new FormGroup({
          idUbicacion: new FormControl(
            this.edit?.condicion?.activo?.ubicacion?.idUbicacion,
          ),
          dentro: new FormControl(
            this.edit?.condicion?.activo?.ubicacion?.dentro !== false
              ? true
              : false,
          ),
          fuera: new FormControl(
            this.edit?.condicion?.activo?.ubicacion?.fuera !== false
              ? true
              : false,
          ),
        }),
        velocidad: new FormGroup({
          'superior a': new FormControl(
            this.edit?.condicion?.activo?.velocidad?.['superior a'] || 60,
          ),
          tiempoMinimo: new FormControl(
            this.edit?.condicion?.activo?.velocidad?.tiempoMinimo,
          ),
        }),
        excesoVelocidadCalle: new FormGroup({
          tolerancia: new FormControl(
            this.edit?.condicion?.activo?.excesoVelocidadCalle?.tolerancia ??
              10,
          ),
          umbralFallback: new FormControl(
            this.edit?.condicion?.activo?.excesoVelocidadCalle?.umbralFallback,
          ),
          tiempoMinimo: new FormControl(
            this.edit?.condicion?.activo?.excesoVelocidadCalle?.tiempoMinimo,
          ),
        }),
        detenido: new FormGroup({
          'mas de': new FormControl(
            this.edit?.condicion?.activo?.detenido?.['mas de'] || 15,
          ),
        }),
        recorridos: new FormGroup({
          distancia: new FormControl(
            this.edit?.condicion?.activo?.recorridos?.['distancia'] ?? 100,
          ),
          dentro: new FormControl(
            this.edit?.condicion?.activo?.recorridos?.dentro !== false
              ? true
              : false,
          ),
          fuera: new FormControl(
            this.edit?.condicion?.activo?.recorridos?.fuera !== false
              ? true
              : false,
          ),
        }),
        divergenciaGPS: new FormControl(
          this.edit?.condicion?.activo?.divergenciaGPS || false,
        ),
      }),

      //Luminaria
      luminaria: new FormGroup({
        potencia: new FormGroup({
          'superior a': new FormControl(
            this.edit?.condicion?.luminaria?.potencia?.['superior a'] || 20,
          ),
          'inferior a': new FormControl(
            this.edit?.condicion?.luminaria?.potencia?.['inferior a'] || 80,
          ),
        }),
        voltaje: new FormGroup({
          'superior a': new FormControl(
            this.edit?.condicion?.luminaria?.voltaje?.['superior a'] || 220,
          ),
          'inferior a': new FormControl(
            this.edit?.condicion?.luminaria?.voltaje?.['inferior a'] || 220,
          ),
        }),
      }),
      //
      alarma: new FormGroup({
        'llega evento': new FormControl(
          this.edit?.condicion?.alarma?.['llega evento']?.length === 1
            ? this.edit?.condicion?.alarma?.['llega evento'][0]
            : null,
        ),
        'no llega evento': new FormControl(
          this.edit?.condicion?.alarma?.['no llega evento']?.length === 1
            ? this.edit?.condicion?.alarma?.['no llega evento'][0]
            : null,
        ),
        ///
        tipoCodigo: new FormControl(textTipo),
      }),
    });

    // El cronograma se guarda en UTC: se edita en la hora local del usuario.
    const cronograma = cronogramaUtcALocal({
      dias: this.edit?.dias,
      horaInicio: this.edit?.horaInicio,
      horaFin: this.edit?.horaFin,
    });
    this.form = new FormGroup({
      tipoEnvio: new FormControl(this.edit?.tipoEnvio || 'Notificacion Push'),
      tipoEntidad: new FormControl(
        this.edit?.tipoEntidad ||
          this.params.tipoEntidad ||
          this.tiposEntidades[0].value,
      ),
      idListadoCategoria: new FormControl(this.edit?.idListadoCategoria),
      idCategoriaEvento: new FormControl(this.edit?.idCategoriaEvento),
      condicion,
      agrupacion: new FormControl(
        this.edit?.agrupacion || this.params.agrupacion || 'Entidad',
      ),
      // idCliente: new FormControl(this.data?.idCliente),
      idGrupo: new FormControl(this.edit?.idGrupo || this.params.idGrupo),
      idEntidad: new FormControl(
        this.edit?.idEntidad ||
          this.params.idEntidad ||
          this.edit?.activo?._id ||
          this.edit?.alarma?._id ||
          this.edit?.luminaria?._id,
      ),

      idsUsuarios: new FormControl(this.edit?.idsUsuarios),
      generarSiNoSeCumple: new FormControl(this.edit?.generarSiNoSeCumple),
      generarSoloUnaVez: new FormControl(this.edit?.generarSoloUnaVez),
      validaDesde: new FormControl(this.edit?.validaDesde),
      validaHasta: new FormControl(this.edit?.validaHasta),
      notificar: new FormControl(this.edit?.notificar),
      atender: new FormControl(this.edit?.atender),
      dias: new FormControl(cronograma.dias),
      horaInicio: new FormControl(cronograma.horaInicio || '00:00'),
      horaFin: new FormControl(cronograma.horaFin || '23:59'),
      frecuencia: new FormControl(this.edit?.frecuencia),
      configZona: new FormGroup({
        particion: new FormControl(this.edit?.configZona?.particion),
        zona: new FormControl(this.edit?.configZona?.zona),
      }),
      // Solo para el form, no está en el modelo
      tipoCondicion: new FormControl(this.condicionInicial()),
    });

    // Si la entidad elegida es una luminaria, por defecto la frecuencia es continua
    this.form
      .get('tipoEntidad')
      ?.valueChanges.subscribe((tipoEntidad: TipoEntidad) => {
        if (tipoEntidad === 'Luminaria') {
          this.form.get('frecuencia')?.setValue('Continua');
        } else {
          this.form.get('frecuencia')?.setValue('');
        }
      });

    // Al pasar a Cronograma sin días cargados, arranca de lunes a viernes.
    this.form.get('frecuencia')?.valueChanges.subscribe((frecuencia) => {
      const dias = this.form.get('dias');
      if (frecuencia === 'Cronograma' && !dias?.value?.length) {
        dias?.setValue(['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes']);
      }
    });

    // Si la condición nueva no admite la frecuencia elegida (p. ej. "Única"
    // con Detenido), se descarta para que el usuario elija otra.
    this.form.get('tipoCondicion')?.valueChanges.subscribe(() => {
      const frecuencia = this.form.get('frecuencia')?.value;
      const disponibles = this.frecuenciasDisponibles.map((f) => f.value);
      if (frecuencia && !disponibles.includes(frecuencia)) {
        this.form.get('frecuencia')?.setValue('');
      }
    });
  }

  //
  public setCodigo(cod: ICodigoDispositivo) {
    if (cod) {
      this.mostrarZona = cod.mostrarZona;
    } else {
      this.mostrarZona = false;
    }
  }

  private getData() {
    const data: IUpdateConfigEventoUsuario | ICreateConfigEventoUsuario =
      this.form?.value;

    // Parsea lo relacionado a la frecuencia. Si la condición no admite
    // elegir (divergencia GPS), es continua.
    const frecuencia = this.muestraFrecuencia
      ? this.form?.get('frecuencia')?.value
      : 'Continua';
    data.frecuencia = frecuencia;
    if (frecuencia === 'Unica') {
      data.generarSoloUnaVez = true;
      data.validaDesde = null;
      data.validaHasta = null;
      data.generarSiNoSeCumple = null;
      data.dias = null;
      data.horaInicio = null;
      data.horaFin = null;
    } else if (frecuencia === 'Continua') {
      data.generarSoloUnaVez = null;
      data.validaDesde = null;
      data.validaHasta = null;
      data.generarSiNoSeCumple = null;
      data.dias = null;
      data.horaInicio = null;
      data.horaFin = null;
    } else if (frecuencia === 'Unica en un periodo') {
      data.generarSoloUnaVez = true;
      data.validaDesde = this.range?.start;
      data.validaHasta = this.range?.end;
      data.dias = null;
      data.horaInicio = null;
      data.horaFin = null;
    } else if (frecuencia === 'Continua en un periodo') {
      data.generarSoloUnaVez = null;
      data.generarSiNoSeCumple = null;
      data.validaDesde = this.range?.start;
      data.validaHasta = this.range?.end;
      data.dias = null;
      data.horaInicio = null;
      data.horaFin = null;
    } else if (frecuencia === 'Cronograma') {
      data.generarSoloUnaVez = null;
      data.validaDesde = null;
      data.validaHasta = null;
      data.generarSiNoSeCumple = null;
      // Se carga en hora local; el backend guarda y compara en UTC.
      const utc = cronogramaLocalAUtc({
        dias: data.dias,
        horaInicio: data.horaInicio,
        horaFin: data.horaFin,
      });
      data.dias = utc.dias;
      data.horaInicio = utc.horaInicio;
      data.horaFin = utc.horaFin;
    }

    if (!this.admiteGenerarSiNoSeCumple) data.generarSiNoSeCumple = null;

    // Parsea lo relacionado a la condición
    const tipoCondicion = this.form?.get('tipoCondicion')?.value;
    if (this.tipoEntidad === 'Activo' || this.tipoEntidad === 'Vehiculo') {
      if (tipoCondicion === 'Ubicación') {
        data.condicion = {
          activo: {
            ubicacion: this.configUbicacionActivo?.value,
          },
        };
      } else if (tipoCondicion === 'Velocidad') {
        const velocidad = this.configVelocidadActivo?.value;
        data.condicion = {
          activo: {
            velocidad: {
              'superior a': velocidad?.['superior a'],
              // Opcional: solo se envía si el usuario cargó un valor
              tiempoMinimo: velocidad?.tiempoMinimo || undefined,
            },
          },
        };
      } else if (tipoCondicion === 'Exceso de velocidad por calle') {
        const exceso = this.configExcesoVelocidadCalleActivo?.value;
        data.condicion = {
          activo: {
            excesoVelocidadCalle: {
              tolerancia: exceso?.tolerancia ?? 10,
              // Opcional: solo se envía si el usuario cargó un valor
              umbralFallback: exceso?.umbralFallback || undefined,
              tiempoMinimo: exceso?.tiempoMinimo || undefined,
            },
          },
        };
      } else if (tipoCondicion === 'Detenido') {
        data.condicion = {
          activo: {
            detenido: this.configDetenidoActivo?.value,
          },
        };
      } else if (tipoCondicion === 'Recorridos') {
        data.condicion = {
          activo: {
            recorridos: this.configRecorridosActivo?.value,
          },
        };
      } else if (tipoCondicion === 'Divergencia GPS') {
        data.condicion = {
          activo: {
            divergenciaGPS: this.configDivergenciaGPSActivo?.value,
          },
        };
      }
    }
    //Luminaria
    else if (this.tipoEntidad === 'Luminaria') {
      if (tipoCondicion === 'Potencia') {
        data.condicion = {
          luminaria: {
            potencia: this.configPotenciaLuminaria?.value,
          },
        };
      } else if (tipoCondicion === 'Voltaje') {
        data.condicion = {
          luminaria: {
            voltaje: this.configVoltajeLuminaria?.value,
          },
        };
      }
    }
    /////////
    else if (this.tipoEntidad === 'Alarma') {
      if (tipoCondicion === 'Llega evento') {
        if (this.condicionAlarma.value.tipoCodigo === 'Codigos de Armado') {
          const codigos = this.codigosAlarma
            .filter((c) => c.armado === true)
            .map((c) => c.codigo);
          data.condicion = {
            alarma: {
              'llega evento': codigos,
            },
          };
        } else if (
          this.condicionAlarma.value.tipoCodigo === 'Codigos de Desarmado'
        ) {
          const codigos = this.codigosAlarma
            .filter((c) => c.desarmado === true)
            .map((c) => c.codigo);
          data.condicion = {
            alarma: {
              'llega evento': codigos,
            },
          };
        } else {
          data.condicion = {
            alarma: {
              'llega evento': [this.configLLegaEventoAlarma?.value],
            },
          };
        }
      } else if (tipoCondicion === 'No llega evento') {
        if (this.condicionAlarma.value.tipoCodigo === 'Codigos de Armado') {
          const codigos = this.codigosAlarma
            .filter((c) => c.armado === true)
            .map((c) => c.codigo);
          data.condicion = {
            alarma: {
              'no llega evento': codigos,
            },
          };
        } else if (
          this.condicionAlarma.value.tipoCodigo === 'Codigos de Desarmado'
        ) {
          const codigos = this.codigosAlarma
            .filter((c) => c.desarmado === true)
            .map((c) => c.codigo);
          data.condicion = {
            alarma: {
              'no llega evento': codigos,
            },
          };
        } else {
          data.condicion = {
            alarma: {
              'no llega evento': [this.configNoLlegaEventoAlarma?.value],
            },
          };
        }
      }
    }

    return data;
  }

  public async onSubmit(): Promise<void> {
    this.loading = true;
    try {
      const data = this.getData();
      let res;
      if (this.edit?._id) {
        res = await this.service.update(this.edit?._id, data);
        this.helper.notifSuccess('Editado correctamente');
      } else {
        res = await this.service.create(data);
        this.helper.notifSuccess('Creado correctamente');
      }
      this.volver(res);
    } catch (err) {
      console.error(err);
      this.helper.notifError(err);
    }
    this.loading = false;
  }

  private condicionInicial() {
    if (this.params.tipoCondicion) return this.params.tipoCondicion;
    if (this.edit?.condicion?.activo?.ubicacion?.idUbicacion)
      return 'Ubicación';
    if (this.edit?.condicion?.activo?.velocidad) return 'Velocidad';
    if (this.edit?.condicion?.activo?.excesoVelocidadCalle)
      return 'Exceso de velocidad por calle';
    if (this.edit?.condicion?.activo?.detenido) return 'Detenido';
    if (this.edit?.condicion?.activo?.recorridos) return 'Recorridos';
    if (this.edit?.condicion?.activo?.divergenciaGPS) return 'Divergencia GPS';
    if (this.edit?.condicion?.luminaria?.potencia) return 'Potencia';
    if (this.edit?.condicion?.luminaria?.voltaje) return 'Voltaje';
    if (this.edit?.condicion?.alarma?.['llega evento']) return 'Llega evento';
    if (this.edit?.condicion?.alarma?.['no llega evento'])
      return 'No llega evento';

    return 'Ubicación';
  }

  //

  public async addTag(t: string) {
    if (!this.creandoNuevoTag) {
      this.creandoNuevoTag = true;
      const listadoCategoria: ICreateListadoCategoria = {
        nombre: t,
        categoria:
          this.form.value.tipoEntidad === 'Alarma'
            ? 'Evento-Alarma'
            : 'Evento-Tracker',
      };
      try {
        const res =
          await this.listadoCategoriasService.create(listadoCategoria);
        this.form.patchValue({ idListadoCategoria: res._id });
        this.creandoNuevoTag = false;
      } catch {
        this.creandoNuevoTag = false;
      }
    }
  }

  public volver(res?: any) {
    if (this.dialogRef) {
      this.dialogRef.close(res);
    } else {
      HelperService.volver();
    }
  }

  public searchUsuario = (term: string, item: IUsuario) => {
    if (item.usuario?.toLowerCase().includes(term.toLowerCase())) return true;
    if (
      item.datosPersonales?.nombre?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (
      item.datosPersonales?.telefono?.toLowerCase().includes(term.toLowerCase())
    )
      return true;
    if (item.datosPersonales?.email?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  public searchCodigo = (term: string, item: ICodigoDispositivo) => {
    if (item.codigo?.toLowerCase().includes(term.toLowerCase())) return true;
    if (item.descripcion?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  public changeAlarma(alarma: IDispositivoAlarma) {
    this.codigosAlarma = alarma?.modelo?.codigos?.codigos;
  }

  public changeTipoCodigo() {
    if (this.tipoEntidad === 'Alarma') {
      this.condicionAlarma.patchValue({
        'llega evento': [],
        'no llega evento': [],
      });
      if (this.condicionAlarma.value.tipoCodigo === 'Codigo Unico') {
        this.tipoCondicion === 'Llega evento'
          ? this.condicionAlarma
              .get('llega evento')
              .setValidators([Validators.required])
          : this.condicionAlarma.get('llega evento').setValidators(null);
        this.tipoCondicion === 'No llega evento'
          ? this.condicionAlarma
              .get('no llega evento')
              .setValidators([Validators.required])
          : this.condicionAlarma.get('no llega evento').setValidators(null);
      } else {
        this.condicionAlarma.get('no llega evento').setValidators(null);
        this.condicionAlarma.get('llega evento').setValidators(null);
      }
      this.condicionAlarma.get('llega evento').updateValueAndValidity();
      this.condicionAlarma.get('no llega evento').updateValueAndValidity();
    }
  }

  private changeTipoEntidad(entidad: string) {
    entidad === 'Alarma'
      ? this.condicionAlarma
          .get('tipoCodigo')
          .setValidators([Validators.required])
      : this.condicionAlarma.get('tipoCodigo').setValidators(null);
    this.condicionAlarma.get('tipoCodigo').updateValueAndValidity();
  }

  // Listados
  private async listarListadoCategoria(): Promise<void> {
    try {
      this.listadoCategorias$?.unsubscribe();
      const data = await firstValueFrom(this.lista2.listadoCategorias({}, 30));
      const listadoCategorias = data.datos;
      this.listadoCategoriasActivos = listadoCategorias.filter(
        (t) => t.categoria === 'Evento-Tracker',
      );
      this.listadoCategoriasAlarmas = listadoCategorias.filter(
        (t) => t.categoria === 'Evento-Alarma',
      );
      this.listadoCategoriasLuminarias = listadoCategorias.filter(
        (t) => t.categoria === 'Evento-Luminaria',
      );
      this.listadoCategoriasTracker = listadoCategorias.filter(
        (t) => t.categoria === 'Evento-Tracker',
      );
    } catch (error) {
      console.error('Error cargando listado categorías:', error);
      this.listadoCategoriasActivos = [];
      this.listadoCategoriasAlarmas = [];
      this.listadoCategoriasLuminarias = [];
      this.listadoCategoriasTracker = [];
    }
  }

  public async listarCategorias(): Promise<void> {
    try {
      this.categoriasEvento$?.unsubscribe();
      const data = await firstValueFrom(this.lista2.categoriaEventos({}, 30));
      this.categoriasEvento = data.datos;
    } catch (error) {
      console.error('Error al cargar categorías:', error);
      this.categoriasEvento = [];
    }
  }

  private async listarGrupos(): Promise<void> {
    try {
      const query: IQueryParam = {
        select: 'nombre idCliente',
        sort: 'nombre',
        includeChildren: true,
      };
      this.grupos$?.unsubscribe();
      const data = await firstValueFrom(this.lista2.grupos(query, 30));
      this.grupos = data.datos;
    } catch (error) {
      console.error('Error cargando grupos:', error);
      this.grupos = [];
    }
  }

  private async listarUsuarios(): Promise<void> {
    try {
      const query: IQueryParam = {
        select: 'usuario datosPersonales.telefono permisos',
        sort: 'usuario',
        includeChildren: true,
      };
      this.usuarios$?.unsubscribe();
      const data = await firstValueFrom(this.lista2.usuarios(query, 30));
      this.usuarios = data.datos;
    } catch (error) {
      console.error('Error cargando usuarios:', error);
      this.usuarios = [];
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //Listar activos, vehículos, alarmas, luminarias
  //Activos:
  searchActivos$: Observable<IActivo[]>; // Observable para los resultados de búsqueda.
  loadingActivos: boolean = false; // Para mostrar el indicador de carga si lo deseas.
  searchTermActivos$ = new Subject<string>(); // Subject para emitir el término de búsqueda

  // Función para emitir el término de búsqueda cuando el usuario escribe
  searchActivos(term: string): void {
    this.searchTermActivos$.next(term); // Emitir el término al Subject
  }

  //Vehiculos:
  searchVehiculos$: Observable<IActivo[]>; // Observable para los resultados de búsqueda.
  loadingVehiculos: boolean = false; // Para mostrar el indicador de carga si lo deseas.
  searchTermVehiculos$ = new Subject<string>(); // Subject para emitir el término de búsqueda

  // Función para emitir el término de búsqueda cuando el usuario escribe
  searchVehiculos(term: string): void {
    this.searchTermVehiculos$.next(term); // Emitir el término al Subject
  }

  //Luminarias:
  searchLuminarias$: Observable<ILuminaria[]>; // Observable para los resultados de búsqueda.
  loadingLuminarias: boolean = false; // Para mostrar el indicador de carga si lo deseas.
  searchTermLuminarias$ = new Subject<string>(); // Subject para emitir el término de búsqueda

  // Función para emitir el término de búsqueda cuando el usuario escribe
  searchLuminarias(term: string): void {
    this.searchTermLuminarias$.next(term); // Emitir el término al Subject
  }

  //Alarmas:
  searchAlarmas$: Observable<IDispositivoAlarma[]>; // Observable para los resultados de búsqueda.
  loadingAlarmas: boolean = false; // Para mostrar el indicador de carga si lo deseas.
  searchTermAlarmas$ = new Subject<string>(); // Subject para emitir el término de búsqueda

  // Función para emitir el término de búsqueda cuando el usuario escribe
  searchAlarmas(term: string): void {
    this.searchTermAlarmas$.next(term); // Emitir el término al Subject
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private async listarUbicaciones(): Promise<void> {
    try {
      const filter: IFilter<IUbicacion> = {
        categoria:
          this.params.tipoEntidad === 'Activo'
            ? 'Activos'
            : {
                $in: ['Zona', 'Vehiculos', 'Hospital', 'Centro de Atención'],
              },
      };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        select: 'identificacion',
        sort: 'identificacion',
        includeChildren: true,
      };
      this.ubicacions$?.unsubscribe();
      const data = await firstValueFrom(this.lista2.ubicacions(query, 30));
      this.ubicacions = data.datos;
    } catch (error) {
      console.error('Error cargando ubicaciones:', error);
      this.ubicacions = [];
    }
  }

  //

  //CREAR CATEGORÍA:

  public crearCategoria() {
    const dialog = this.formularios.abrir(CrearEditarCategoriaEventoComponent, {
      tamano: 'mediano',
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.form.patchValue({ idCategoriaEvento: res });
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.tiposEntidades = [
      this.permisosEntidadesService.verModuloActivos()
        ? { label: 'Activo', value: 'Activo' }
        : null,
      this.permisosEntidadesService.verModuloVehiculos()
        ? { label: 'Vehículo', value: 'Vehiculo' }
        : null,
      this.permisosEntidadesService.verModuloAlarmas()
        ? { label: 'Alarma', value: 'Alarma' }
        : null,
      this.permisosEntidadesService.verModuloLuminarias()
        ? { label: 'Luminaria', value: 'Luminaria' }
        : null,
    ].filter((e): e is { label: string; value: TipoEntidad } => e !== null);
    // Params - Obtener datos de entrada desde dialogData o paramsService
    this.edit = this.dialogData?.edit || this.paramsService.getParams()['edit'];
    this.params =
      this.dialogData?.params || this.paramsService.getParams()['params'];

    // Configurar códigos de alarma iniciales
    this.codigosAlarma =
      (this.params?.alarma as IDispositivoAlarma)?.modelo?.codigos?.codigos ||
      [];
    this.mostrarZona =
      this.edit?.configZona?.zona || this.edit?.configZona?.particion
        ? true
        : false;

    // Configurar datos iniciales si es edición
    if (this.edit) {
      this.range = {
        start: this.edit?.validaDesde,
        end: this.edit?.validaHasta,
      };
    }

    // Crear formulario
    this.createForm();

    // Configurar listeners del formulario
    this.form
      .get('tipoCondicion')
      ?.valueChanges.subscribe(() => this.changeTipoCodigo());
    if (this.form.value.tipoEntidad === 'Alarma')
      this.changeTipoEntidad('Alarma');
    this.form.get('tipoEntidad')?.valueChanges.subscribe((value) => {
      this.changeTipoEntidad(value);
      this.form.get('idListadoCategoria')?.setValue(null);
      this.listadoCategoriaInitialNames = [];
    });

    // Esperar a que se carguen los listados básicos
    await Promise.all([
      this.listarCategorias(),
      this.listarListadoCategoria(),
      this.listarGrupos(),
      this.listarUsuarios(),
      this.listarUbicaciones(),
    ]);

    // Resolver nombre inicial del listado categoría para el selector (modo edición)
    if (this.edit?.idListadoCategoria) {
      try {
        const cat = await this.listadoCategoriasService.getById(
          this.edit.idListadoCategoria,
        );
        this.listadoCategoriaInitialNames = cat?.nombre ? [cat.nombre] : [];
      } catch {
        this.listadoCategoriaInitialNames = [];
      }
    }

    // CONFIGURAR BÚSQUEDAS DESPUÉS DE CARGAR DATOS BÁSICOS
    this.configurarBusquedas();

    // Cargar datos de búsqueda inicial si es edición
    if (this.edit) {
      const tipoEntidad = this.edit?.tipoEntidad || this.params?.tipoEntidad;
      switch (tipoEntidad) {
        case 'Activo':
          this.searchTermActivos$.next(this.edit?.activo?.identificacion || '');
          // Precargar la lista de activos con el activo actual
          if (this.edit?.activo) {
            this.activos = [this.edit.activo];
          }
          break;
        case 'Vehiculo':
          this.searchTermVehiculos$.next(
            this.edit?.activo?.identificacion || '',
          );
          // Precargar la lista de vehículos con el vehículo actual
          if (this.edit?.activo) {
            this.vehiculos = [this.edit.activo];
          }
          break;
        case 'Alarma':
          this.searchTermAlarmas$.next(
            this.edit?.alarma?.nombre ||
              (this.params?.alarma as IDispositivoAlarma)?.nombre ||
              '',
          );
          // Precargar la lista de alarmas con la alarma actual
          if (this.edit?.alarma) {
            this.alarmas = [this.edit.alarma];
            // Cargar códigos de la alarma
            this.codigosAlarma =
              this.edit.alarma?.modelo?.codigos?.codigos || [];
            this.changeAlarma(this.edit.alarma);
          }
          break;
        case 'Luminaria':
          this.searchTermLuminarias$.next(
            this.edit?.luminaria?.identificacion || '',
          );
          // Precargar la lista de luminarias con la luminaria actual
          if (this.edit?.luminaria) {
            this.luminarias = [this.edit.luminaria];
          }
          break;
        default:
          break;
      }

      // Forzar detección de cambios para actualizar ng-select
      this.cdr.detectChanges();

      // Trigger a search with current value to populate ng-select
      setTimeout(() => {
        switch (tipoEntidad) {
          case 'Activo':
            if (this.edit?.activo?.identificacion) {
              this.searchActivos(this.edit.activo.identificacion);
            } else {
              // Trigger with empty string to show preloaded items
              this.searchTermActivos$.next('');
            }
            break;
          case 'Vehiculo':
            if (this.edit?.activo?.identificacion) {
              this.searchVehiculos(this.edit.activo.identificacion);
            } else {
              // Trigger with empty string to show preloaded items
              this.searchTermVehiculos$.next('');
            }
            break;
          case 'Alarma':
            if (this.edit?.alarma?.nombre) {
              this.searchAlarmas(this.edit.alarma.nombre);
            } else {
              // Trigger with empty string to show preloaded items
              this.searchTermAlarmas$.next('');
            }
            break;
          case 'Luminaria':
            if (this.edit?.luminaria?.identificacion) {
              this.searchLuminarias(this.edit.luminaria.identificacion);
            } else {
              // Trigger with empty string to show preloaded items
              this.searchTermLuminarias$.next('');
            }
            break;
        }
      }, 100);
    }
  }

  private configurarBusquedas(): void {
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //SUSCRIPCIONES A ACTIVOS, VEHÍCULOS, ALARMAS Y LUMINARIAS:

    //ACTIVOS:

    //ACTIVOS:
    const searchActivosBase$ = this.searchTermActivos$.pipe(
      debounceTime(200), // Esperar 200ms después de que el usuario deje de escribir
      distinctUntilChanged(), // Evitar solicitudes si el término no ha cambiado
      switchMap((term) => {
        this.loadingActivos = true; // Activar el indicador de carga

        // Si el término tiene menos de 3 caracteres, no realizamos la búsqueda.
        // Si el término está vacío, devolver un observable vacío sin activar el indicador de carga.
        if (!term || term.length < 3) {
          this.loadingActivos = false; // Desactivar el indicador de carga si el término está vacío o tiene menos de 3 caracteres
          return of([]); // Retorna una lista vacía
        }
        this.loadingActivos = true; // Activar el indicador de carga solo cuando realmente estamos buscando
        // Crear filtro cuando el término no es vacío
        const filter: IFilter<IActivo> = {
          identificacion: { $regex: term, $options: 'i' },
          categoria: 'Normal',
        };

        const queryActivos: IQueryParam = {
          includeChildren: true,
          childrenLevel: 0,
          filter: JSON.stringify(filter),
        };

        return this.lista2.activos(queryActivos).pipe(
          map((data: IListado<IActivo>) => data.datos), // Extraer el array datos del objeto IListado
        ); // Llamada al servicio
      }),
    );

    // Combinar resultados de búsqueda con activos precargados
    this.searchActivos$ = searchActivosBase$.pipe(
      map((searchResults) => {
        // Si hay activos precargados y no hay resultados de búsqueda, mostrar los precargados
        if (
          this.activos &&
          this.activos.length > 0 &&
          searchResults.length === 0
        ) {
          return this.activos;
        }
        // Si hay resultados de búsqueda, combinar con precargados (sin duplicados)
        if (searchResults.length > 0) {
          const combined = [...searchResults];
          // Agregar activos precargados que no estén ya en los resultados
          this.activos.forEach((activo) => {
            if (!combined.find((item) => item._id === activo._id)) {
              combined.unshift(activo); // Agregar al inicio
            }
          });
          return combined;
        }
        return searchResults;
      }),
    );

    // Suscripción para actualizar el indicador de carga.
    this.searchActivos$.subscribe({
      next: () => {
        this.loadingActivos = false; // Desactivar el indicador de carga
      },
      error: () => {
        this.loadingActivos = false; // Desactivar en caso de error también
      },
    });

    //VEHÍCULOS
    const searchVehiculosBase$ = this.searchTermVehiculos$.pipe(
      debounceTime(200), // Esperar 200ms después de que el usuario deje de escribir
      distinctUntilChanged(), // Evitar solicitudes si el término no ha cambiado
      switchMap((term) => {
        this.loadingVehiculos = true; // Activar el indicador de carga

        // Si el término tiene menos de 3 caracteres, no realizamos la búsqueda.
        // Si el término está vacío, devolver un observable vacío sin activar el indicador de carga.
        if (!term || term.length < 3) {
          this.loadingVehiculos = false; // Desactivar el indicador de carga si el término está vacío o tiene menos de 3 caracteres
          return of([]); // Retorna una lista vacía
        }
        this.loadingVehiculos = true; // Activar el indicador de carga solo cuando realmente estamos buscando
        // Crear filtro cuando el término no es vacío
        const filter: IFilter<IActivo> = {
          identificacion: { $regex: term, $options: 'i' },
        };

        const queryVehiculos: IQueryParam = {
          includeChildren: true,
          childrenLevel: 0,
          filter: JSON.stringify(filter),
        };

        return this.lista2.vehiculos(queryVehiculos).pipe(
          map((data: IListado<IActivo>) => data.datos), // Extraer el array datos del objeto IListado
        ); // Llamada al servicio Nota: los vehículos son un tipo de activo
      }),
    );

    // Combinar resultados de búsqueda con vehículos precargados
    this.searchVehiculos$ = searchVehiculosBase$.pipe(
      map((searchResults) => {
        // Si hay vehículos precargados y no hay resultados de búsqueda, mostrar los precargados
        if (
          this.vehiculos &&
          this.vehiculos.length > 0 &&
          searchResults.length === 0
        ) {
          return this.vehiculos;
        }
        // Si hay resultados de búsqueda, combinar con precargados (sin duplicados)
        if (searchResults.length > 0) {
          const combined = [...searchResults];
          // Agregar vehículos precargados que no estén ya en los resultados
          this.vehiculos.forEach((vehiculo) => {
            if (!combined.find((item) => item._id === vehiculo._id)) {
              combined.unshift(vehiculo); // Agregar al inicio
            }
          });
          return combined;
        }
        return searchResults;
      }),
    );

    // Suscripción para actualizar el indicador de carga.
    this.searchVehiculos$.subscribe({
      next: () => {
        this.loadingVehiculos = false; // Desactivar el indicador de carga
      },
      error: () => {
        this.loadingVehiculos = false; // Desactivar en caso de error también
      },
    });

    //LUMINARIAS:
    const searchLuminariasBase$ = this.searchTermLuminarias$.pipe(
      debounceTime(200), // Esperar 200ms después de que el usuario deje de escribir
      distinctUntilChanged(), // Evitar solicitudes si el término no ha cambiado
      switchMap((term) => {
        this.loadingLuminarias = true; // Activar el indicador de carga

        // Si el término tiene menos de 3 caracteres, no realizamos la búsqueda.
        // Si el término está vacío, devolver un observable vacío sin activar el indicador de carga.
        if (!term || term.length < 3) {
          this.loadingLuminarias = false; // Desactivar el indicador de carga si el término está vacío o tiene menos de 3 caracteres
          return of([]); // Retorna una lista vacía
        }
        this.loadingLuminarias = true; // Activar el indicador de carga solo cuando realmente estamos buscando
        // Crear filtro cuando el término no es vacío
        const filter: IFilter<ILuminaria> = {
          identificacion: { $regex: term, $options: 'i' },
        };

        const queryLuminarias: IQueryParam = {
          includeChildren: true,
          childrenLevel: 0,
          filter: JSON.stringify(filter),
        };

        return this.lista2.luminarias(queryLuminarias).pipe(
          map((data: IListado<ILuminaria>) => data.datos), // Extraer el array datos del objeto IListado
        ); // Llamada al servicio
      }),
    );

    // Combinar resultados de búsqueda con luminarias precargadas
    this.searchLuminarias$ = searchLuminariasBase$.pipe(
      map((searchResults) => {
        // Si hay luminarias precargadas y no hay resultados de búsqueda, mostrar las precargadas
        if (
          this.luminarias &&
          this.luminarias.length > 0 &&
          searchResults.length === 0
        ) {
          return this.luminarias;
        }
        // Si hay resultados de búsqueda, combinar con precargadas (sin duplicados)
        if (searchResults.length > 0) {
          const combined = [...searchResults];
          // Agregar luminarias precargadas que no estén ya en los resultados
          this.luminarias.forEach((luminaria) => {
            if (!combined.find((item) => item._id === luminaria._id)) {
              combined.unshift(luminaria); // Agregar al inicio
            }
          });
          return combined;
        }
        return searchResults;
      }),
    );

    // Suscripción para actualizar el indicador de carga.
    this.searchLuminarias$.subscribe({
      next: () => {
        this.loadingLuminarias = false; // Desactivar el indicador de carga
      },
      error: () => {
        this.loadingLuminarias = false; // Desactivar en caso de error también
      },
    });

    //ALARMAS
    const searchAlarmasBase$ = this.searchTermAlarmas$.pipe(
      debounceTime(200), // Esperar 200ms después de que el usuario deje de escribir
      distinctUntilChanged(), // Evitar solicitudes si el término no ha cambiado
      switchMap((term) => {
        this.loadingAlarmas = true; // Activar el indicador de carga

        // Si el término tiene menos de 3 caracteres, no realizamos la búsqueda.
        // Si el término está vacío, devolver un observable vacío sin activar el indicador de carga.
        if (!term || term.length < 3) {
          this.loadingAlarmas = false; // Desactivar el indicador de carga si el término está vacío o tiene menos de 3 caracteres
          return of([]); // Retorna una lista vacía
        }
        this.loadingAlarmas = true; // Activar el indicador de carga solo cuando realmente estamos buscando
        // Crear filtro cuando el término no es vacío
        const filter: IFilter<IDispositivoAlarma> = {
          nombre: { $regex: term, $options: 'i' },
        };
        const populate = {
          path: 'modelo',
          select: 'idCodigos',
          populate: {
            path: 'codigos',
            select: 'codigos',
          },
        };
        const queryAlarmas: IQueryParam = {
          includeChildren: true,
          childrenLevel: 0,
          filter: JSON.stringify(filter),
          populate: JSON.stringify(populate),
        };

        return this.lista2.dispositivosAlarmas(queryAlarmas).pipe(
          map((data: IListado<IDispositivoAlarma>) => data.datos), // Extraer el array datos del objeto IListado
        ); // Llamada al servicio
      }),
    );

    // Combinar resultados de búsqueda con alarmas precargadas
    this.searchAlarmas$ = searchAlarmasBase$.pipe(
      map((searchResults) => {
        // Si hay alarmas precargadas y no hay resultados de búsqueda, mostrar las precargadas
        if (
          this.alarmas &&
          this.alarmas.length > 0 &&
          searchResults.length === 0
        ) {
          return this.alarmas;
        }
        // Si hay resultados de búsqueda, combinar con precargadas (sin duplicados)
        if (searchResults.length > 0) {
          const combined = [...searchResults];
          // Agregar alarmas precargadas que no estén ya en los resultados
          this.alarmas.forEach((alarma) => {
            if (!combined.find((item) => item._id === alarma._id)) {
              combined.unshift(alarma); // Agregar al inicio
            }
          });
          return combined;
        }
        return searchResults;
      }),
    );

    // Suscripción para actualizar el indicador de carga.
    this.searchAlarmas$.subscribe({
      next: () => {
        this.loadingAlarmas = false; // Desactivar el indicador de carga
      },
      error: () => {
        this.loadingAlarmas = false; // Desactivar en caso de error también
      },
    });
  }

  ngOnDestroy(): void {
    this.categoriasEvento$?.unsubscribe();
    this.grupos$?.unsubscribe();
    this.usuarios$?.unsubscribe();
    this.ubicacions$?.unsubscribe();
    this.listadoCategorias$?.unsubscribe();
  }
}
